(function () {
  'use strict';
  var video = document.querySelector('[data-pt-hero-video]');
  var toggle = document.querySelector('[data-video-toggle]');
  if (!video || !toggle) return;
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobile = window.matchMedia('(max-width:760px)');
  var paused = mobile.matches || motion.matches || !!(navigator.connection && navigator.connection.saveData);
  var inView = true;
  video.muted = true;
  toggle.hidden = false;
  function syncLabel() {
    toggle.textContent = paused ? '▶' : 'Ⅱ';
    toggle.setAttribute('aria-label', paused ? toggle.dataset.play : toggle.dataset.pause);
  }
  function play() {
    if (paused || !inView || document.hidden) { video.pause(); return; }
    if (!video.getAttribute('src')) video.src = mobile.matches ? video.dataset.mobile : video.dataset.desktop;
    var promise = video.play();
    if (promise) promise.catch(function () { paused = true; syncLabel(); });
  }
  video.addEventListener('playing', function () { video.classList.add('is-playing'); });
  video.addEventListener('error', function () { video.classList.remove('is-playing'); toggle.hidden = true; });
  toggle.addEventListener('click', function () { paused = !paused; syncLabel(); play(); });
  motion.addEventListener('change', function (e) { if (e.matches) { paused = true; syncLabel(); play(); } });
  document.addEventListener('visibilitychange', play);
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; play(); }, { threshold:0.05 }).observe(video.closest('.hero'));
  } else play();
  syncLabel();
})();

